
import { FC, useEffect, useState } from 'react';
import { getGoogleAutocompleteCity } from '../services/googleService';
import useGoogle from "react-google-autocomplete/lib/usePlacesAutocompleteService";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Box from '@mui/material/Box';
import { LocationAutocompleteType } from '../typings/google';
import { getCitiesAutoComplete } from '../services/questionService';
import { CitySuggestion } from '../pages/Signup/components/LocationQuestion';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import { GenderType } from '../helpers/Enums';


export type EditLocationProps = {
    onSave: (location: CitySuggestion) => void;
    value: string | undefined;
    title: string | undefined;
    subtitle: string | undefined;
    buttonText: string;
    preLocation?: string;
}

const EditLocation: FC<EditLocationProps> = ({ onSave, value, title, subtitle, buttonText, preLocation }) => {
    // const [location, setLocation] = useState<string>("");
    const {
        placePredictions,
        getPlacePredictions,
        isPlacePredictionsLoading,
    } = useGoogle({
        apiKey: "AIzaSyDnf1niVMSrAxU63vP2LQUWc0XyqqFWeAc",
        options: {
            types: ["(regions)"],
            componentRestrictions: { country: "il" },
        }
    });
    const [location, setLocation] = useState("");
    const [errors, setErrors] = useState<any>({});
    const [locationSuggestionsIsOpen, setlocationSuggestionsIsOpen] = useState<boolean>(false);
    const [selectedLocation, setSelectedLocation] = useState<CitySuggestion>();
    const [citiesSuggestions, setCitiesSuggestions] = useState<CitySuggestion[]>([]);
    const resgiter = useSelector((state: RootState) => state.signup);
    const member = useSelector((state: RootState) => state.member);
    const [genderId, setGenderId] = useState<number>(resgiter.genderId);
    useEffect(() => {
        if (member.memberCode === 0) {
            if (resgiter.genderId === 0) {
                setGenderId(5);
            } else {
                setGenderId(resgiter.genderId);
            }
        } else {
            setGenderId(member.genderId);
        }
        if (preLocation)
            setLocation(preLocation)
    }, [])

    const validateForm = () => {
        let isvalid = true;
        let errors: any = {};
        // if (selectedLocation === "") {
        //     errors["location"] = "חובה להזין מיקום";
        //     isvalid = false;
        // }
        setErrors(errors);
        return isvalid;
    };

    const handleTextChange = async (text: string) => {
        // const data = getPlacePredictions({ input: text });
        const { data } = await getCitiesAutoComplete(text);
        setCitiesSuggestions(data.splice(0, 5));
        setlocationSuggestionsIsOpen(true);
        setSelectedLocation(undefined);
    };

    const onLocationSelect = (suggestion: CitySuggestion) => {
        // const { description, place_id, structured_formatting: { main_text: name } } = location;
        // const locationSelected: LocationAutocompleteType = {
        //     placeId: place_id,
        //     locationName: name
        // };
        setLocation(suggestion.cityName);
        setSelectedLocation(suggestion);
        setlocationSuggestionsIsOpen(false);

    };

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (selectedLocation) {
            onSave(selectedLocation);
        }

    };

    const enabled = selectedLocation != undefined;


    return (<>

        <div className="content_sec wf-section">

            <div className="signup_top_info">
                <div className="icon_info"><img src="~/assets/images/ic_info_smoke.svg" loading="lazy" alt="" /></div>
                <h2 className="signup_title">{title}</h2>
                <div>{subtitle}</div>
            </div>
            <div className="login_sec w-form">
                <form onSubmit={handleSubmit}>
                    <div className="form_field_content login">
                        <div className="field_block">

                            <input autoComplete="off" name="nickname" type="text" value={location} placeholder={genderId === GenderType.MALE ? "בחר ישוב או עיר" : "בחרי ישוב או עיר"} onChange={e => {
                                setLocation(e.target.value);
                                handleTextChange(e.target.value);
                            }} maxLength={256} className="txt_field place w-input" />
                            <div className="form_allert" style={{ display: errors && errors["location"] ? "contents" : "block" }}>{errors["location"]}</div>
                        </div>
                        {locationSuggestionsIsOpen && citiesSuggestions.length > 0 && (

                            <div className="form_field_content" style={{ backgroundColor: "white", borderRadius: 5 }}>
                                {citiesSuggestions.map((suggestion) => (
                                    <div key={suggestion.id}>
                                        <div onClick={() => onLocationSelect(suggestion)} style={{
                                            fontSize: 20,
                                            padding: 10,
                                            borderBottom: "1px solid rgba(0, 0, 0, 0.10)"
                                        }}
                                        >{suggestion.cityName}</div>
                                    </div>
                                ))}
                            </div>
                        )
                        }
                        <input autoComplete="off" disabled={!enabled} type="submit" value={buttonText} data-wait="" className={enabled ? "button_full w-button" : "button_full inactive  w-button"}></input>
                    </div>
                    {/* <input autoComplete="off" disabled={!enabled} type="submit" value={buttonText} data-wait="" className={enabled ? "button_full w-button" : "button_full send w-button"}></input> */}

                </form>
            </div>
        </div>

    </>)
}


export default EditLocation;